module.exports = __webpack_public_path__ + "img/kefu_img.bfcbab49.png";